<template>
  <v-container
    class="pa-16"
    fluid
    style="background-color: #f5f5f5; z-index: 999999 !important"
  >
    <v-row class="text-center">
      <v-col cols="12" class="text-h5 text-md-h5 text-lg-h4 font-weight-bold">
        <p class="volunteer">
          TEM INTERESSE EM PARTICIPAR DO PROJETO? <br />
          INSCREVA-SE AQUI
        </p>
      </v-col>
      <v-col>
        <v-row justify="center">
          <v-dialog v-model="dialog" max-width="40%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                rounded
                :x-large="
                  $vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.md ||
                  $vuetify.breakpoint.xl
                "
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <span class="volunteerButton">PARTICIPAR</span>
              </v-btn>
            </template>
            <v-form ref="newContactForm" v-model="valid" lazy-validation>
              <v-card>
                <v-toolbar color="primary" dark
                  >Formulário de Contato</v-toolbar
                >
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="form.name"
                          label="Nome completo*"
                          required
                          :rules="fullNameRules"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.email"
                          label="Email*"
                          required
                          :rules="emailRules"
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="form.telephone"
                          v-mask="'(##) #####-####'"
                          label="Telefone"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="form.subjectId"
                          :items="subjects"
                          label="Assunto"
                          required
                          :rules="topicRules"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="form.message"
                          label="Mensagem*"
                          required
                          auto-grow
                          :rules="messageRules"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="dialog = false">
                    Fechar
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="sendEmail">
                    Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import {
  fullNameRules,
  emailRules,
  topicRules,
  messageRules,
} from '@/utils/Rules';
import { sendParticipationEmail } from '@/services/email';

export default {
  name: 'VolunteerWork',
  data() {
    return {
      valid: false,
      fullNameRules,
      emailRules,
      topicRules,
      messageRules,
      form: {
        name: '',
        email: '',
        subjectId: '',
        telephone: '',
        message: '',
      },
      dialog: false,
      subjects: [
        {
          text: 'Quero estudar',
          value: 1,
        },
        {
          text: 'Quero ser voluntário',
          value: 2,
        },
        {
          text: 'Outros',
          value: 3,
        },
      ],
    };
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async sendEmail() {
      try {
        this.showLoading();
        const isValid = this.$refs.newContactForm.validate();
        if (isValid) {
          const { email, name, message, subjectId, telephone } = this.form;
          const subject = this.subjects[subjectId - 1].text || '';
          const { success } = await sendParticipationEmail(
            email,
            name,
            subject,
            message,
            telephone
          );

          if (success) {
            if (this.$root.vtoast) {
              this.$root.vtoast.show({
                message: 'E-mail enviado com sucesso!',
                top: true,
                right: true,
                show: true,
                color: 'success',
              });
            }
          } else {
            this.$root.vtoast.show({
              message:
                'Erro ao enviar e-mail. Por favor, tente novamente mais tarde.',
              top: true,
              right: true,
              show: true,
              color: 'error',
            });
          }
          this.dialog = false;
        }
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message:
              'Erro ao enviar e-mail. Por favor, tente novamente mais tarde.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
        this.dialog = false;
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700;800&display=swap');

body {
  font-family: 'Montserrat', sans-serif;
}

.volunteer {
  color: #137cc0;
}

.volunteerBackground {
  background-image: linear-gradient(#fdc830, #f37335);
}
</style>
